// extracted by mini-css-extract-plugin
export default {"item-details-container":"ItemDetailsSection_item-details-container__KotM5"};